import { LoadState } from '@ally/use-data-domain'
import { AfgCustomerDomain } from '@ally/data-types-host'

import { useHostServices } from '../HostServices'

export type PasswordStrengthIndicator = '1' | '2' | '3' | ''

export const useHostCustomer = (): {
  passwordStrengthIndicator: PasswordStrengthIndicator
  isBankUser: boolean
  isSecurityFFOn: boolean
  hostLoading: LoadState
  afgCustomer: AfgCustomerDomain | null
} => {
  const { hostData, session, featureFlags } = useHostServices()

  const afgCustomer = hostData?.afgCustomer?.data
  const hostLoading = hostData?.afgCustomer?.status?.loadState

  const userRoles = session?.data?.allyUserRole
  const isBankUser = !!userRoles?.bank

  const isSecurityFFOn = featureFlags.variation('FF_badge-security', false)

  const passwordStrengthIndicator = session?.data?.psi ?? ''

  return {
    passwordStrengthIndicator,
    isBankUser,
    isSecurityFFOn,
    afgCustomer,
    hostLoading,
  }
}
